/*
 * Copyright 2025 ixPilot Teknoloji A.Ş. (ixpilot2021@gmail.com)
 * All rights reserved.
 *
 * This software is proprietary and confidential.
 * Unauthorized copying, modification, or distribution of this software,
 * via any medium, is strictly prohibited.
 *
 * Developed and maintained by ixPilot Teknoloji A.Ş.
 */

const baseColumnsAbonelik = [
  { Header: "Cihaz ID", accessor: "cihaz_id" },
  { Header: "Satış Tarihi", accessor: "satis_tarihi", sortable: true },
  { Header: "Satış Türü", accessor: "satis_turu" },
  { Header: "Firma", accessor: "firma" },
  { Header: "İş Ortağı", accessor: "is_ortagi" },
  { Header: "Plaka", accessor: "plaka" },
  { Header: "SIM No", accessor: "sim_no" },
  { Header: "IMEI", accessor: "imei" },
  { Header: "Döngü Durumu", accessor: "dongu_durumu" },
  { Header: "Yenilediği Tarih", accessor: "yenilendigi_tarih", sortable: true },
  { Header: "Döngü Tarihi", accessor: "dongu_tarihi", sortable: true },
  { Header: "Tür", accessor: "tur" },
  { Header: "Kalan Abonelik (Gün)", accessor: "kalan_abonelik", sortable: true },
  { Header: "Döngü Sayısı", accessor: "dongu_sayisi" },
  { Header: "UETDS", accessor: "uetds" },
];

// Role göre kolonları filtrele - bayi rolünde "İş Ortağı" kolonunu gizle
export const getColumnsAbonelik = (userRole) => {
  if (userRole === "bayi") {
    return baseColumnsAbonelik.filter(col => col.accessor !== "is_ortagi");
  }
  return baseColumnsAbonelik;
};

// Backward compatibility için default export
export const columnsAbonelik = baseColumnsAbonelik;

export default columnsAbonelik;
